import PreviewCapturing from "./PreviewCapturing";

export default PreviewCapturing;
